/* eslint-disable prettier/prettier */
export const QUERY = {
  allUser: (roleId = 0) => `
    query MyQuery {
        allUserProfiles(condition: {${roleId > 0 ? `roleId: ${roleId},` :``} isActive: true }) {
          nodes {
            id
            value:id,
            label:firstName,
            email:emailId
            name:firstName
            img:profilePic
            designation: masterRoleByRoleId{
              roleName
            }
          }
        }
      }
    `,
  deleteUser: ({ id, isActive = true }) => `
    mutation MyQuery {
      updateUserProfileById(
        input: { userProfilePatch: { isActive: ${isActive} }, id: "${id}" }
      ) {
        clientMutationId
      }
    }`

};